/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import { z } from 'zod/v4';
import { objectiveSchema } from './objectiveSchema';

export const paginationDocumentObjectiveSchema = z.object({
  cursor: z.string().nullish(),
  get data() {
    return z.array(objectiveSchema);
  },
  recordCount: z.int().nullish(),
  recordLimit: z.int().nullish(),
});
